import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getUsersAwaitingVerification,
  VerificationFilterType,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";
import type { AwaitingVerificationParams } from "Api/Queries/User/awaitingVerificationTypes";

const USERS_AWAITING_IDENTITY_VERIFICATION_QUERY_KEY =
  "USERS_AWAITING_IDENTITY_VERIFICATION";

export const usersAwaitingIdentityVerificationKeys = {
  all: [USERS_AWAITING_IDENTITY_VERIFICATION_QUERY_KEY],
  byParams: (params: AwaitingVerificationParams) => [
    ...usersAwaitingIdentityVerificationKeys.all,
    params,
  ],
};

type QueryOptions = {
  enabled?: boolean;
  params?: AwaitingVerificationParams;
};

export const useUsersAwaitingIdentityVerificationQuery = ({
  enabled,
  params,
}: QueryOptions = {}) =>
  useQuery({
    queryKey: usersAwaitingIdentityVerificationKeys.byParams(params ?? {}),
    queryFn: processResponseWithApiProblemDetails(() =>
      getUsersAwaitingVerification(
        VerificationFilterType.IdentityVerification,
        params?.login,
        params?.firstName,
        params?.lastName,
        params?.companyName,
        params?.companyNumber,
        params?.roleCodes,
        params?.offset,
        params?.limit,
        params?.sortBy,
        params?.sortDirection,
      ),
    ),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    staleTime: MS_TIME.minute,
    enabled,
  });
